import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CostingLevelDialogModule } from './costing-level-dialog/costing-level-dialog.module';
import { CostingLevelPage } from './costing-level.page';


export * from './costing-level.page';
export * from './costing-level-dialog/costing-level-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: CostingLevelPage,
    },
];

@NgModule({
    declarations: [ CostingLevelPage ],
    imports: [
        CommonModule,
        CostingLevelDialogModule,
        RouterModule.forChild(routes),
        MatSelectModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        CostingLevelDialogModule,
        TranslateModule,
        MatRippleModule,
        MatTooltipModule
    ],
})
export class CostingLevelPageModule {
}
